import "core-js/modules/es6.array.for-each";
export default function (array, filter, visitor) {
  if (array) {
    var i = 0,
        n = array.length,
        t;

    if (filter) {
      for (; i < n; ++i) {
        if (t = filter(array[i])) visitor(t, i, array);
      }
    } else {
      array.forEach(visitor);
    }
  }
}